import { Amplify } from "aws-amplify";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { CookieStorage } from "aws-amplify/utils";

// Admin tokens stay in this origin's tab, never in cross-subdomain cookies.
const adminSessionStorage = {
  async setItem(key, value) { window.sessionStorage.setItem(key, value); },
  async getItem(key) { return window.sessionStorage.getItem(key); },
  async removeItem(key) { window.sessionStorage.removeItem(key); },
};

// Keep Cognito tokens in shared cookies so both app modes (author/reader) avoid localStorage-only sessions.
export const getAuthCookieOptions = (hostname, protocol) => ({
  ...(hostname === "bookishcircle.com" || hostname.endsWith(".bookishcircle.com")
    ? { domain: ".bookishcircle.com" }
    : {}),
  path: "/",
  secure: protocol === "https:",
  sameSite: "lax",
});
const sharedCognitoCookieStorage = new CookieStorage(
  getAuthCookieOptions(window.location.hostname, window.location.protocol)
);

cognitoUserPoolsTokenProvider.setKeyValueStorage(sharedCognitoCookieStorage);

const authorConfig = {
  Auth: {
    Cognito: {
      userPoolId: "us-west-2_cUkr88vbl",
      userPoolClientId: "7bnfbn7sm1fspjt4o4s3eagbl9",
      loginWith: {
        email: true,
      },
    },
  },
};

const readerConfig = {
  Auth: {
    Cognito: {
      userPoolId: "us-west-2_o20WF8tra",
      userPoolClientId: "497g26mseqpq630svnua64imcq",
      loginWith: {
        email: true,
      },
    },
  },
};


const adminConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_ADMIN_USER_POOL_ID || "",
      userPoolClientId: process.env.REACT_APP_ADMIN_USER_POOL_CLIENT_ID || "",
      loginWith: { email: true },
    },
  },
};

let configuredAuthType = null;

export const getConfiguredAuthType = () => configuredAuthType;

export const configureAuth = (type) => {
  const nextType = type === "reader" ? "reader" : type === "admin" ? "admin" : "author";

  if (nextType === "reader") Amplify.configure(readerConfig);
  else if (nextType === "admin") Amplify.configure(adminConfig);
  else Amplify.configure(authorConfig);

  // Amplify's first configure installs default (origin-local) storage. Apply
  // our shared storage AFTER configuration, including every pool switch.
  cognitoUserPoolsTokenProvider.setKeyValueStorage(nextType === "admin" ? adminSessionStorage : sharedCognitoCookieStorage);
  configuredAuthType = nextType;
};
